import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useSidebar } from "../../context/SideBarConext";

const DocSection = ({ section, level = 0 }) => {
  const [isOpen, setIsOpen] = useState(false);

  // const toggleSection = () => {
  //   setIsOpen(!isOpen);
  // };
  const { openSections, toggleSection } = useSidebar();
  const sectionId = section.id || section.title.toLowerCase().replace(/\s+/g, '-');


  return (
    <div className={`mb-6 ${level > 0 ? "ml-6" : ""}`}>
    <div
      className="bg-white rounded-lg overflow-hidden transition-all duration-300 ease-in-out hover:shadow-lg"
      style={{ maxHeight: openSections.sections[sectionId] ? "2000px" : "60px" }}
    >
      <button
        className="flex justify-between items-center w-full text-left p-4 bg-gray-50"
        onClick={() => toggleSection(sectionId)}
      >
          <span
            className={`text-${
              20 - level * 2
            }px font-semibold text-gray-800 flex items-center`}
          >
            {section.icon && <span className="mr-3">{section.icon}</span>}
            {section.title}
          </span>
          {isOpen ? (
            <ChevronDown className="text-gray-500 transition-transform duration-300 ease-in-out" />
          ) : (
            <ChevronRight className="text-gray-500 transition-transform duration-300 ease-in-out" />
          )}
        </button>
        <div className={`p-6 ${openSections.sections[sectionId] ? "block" : "hidden"}`}>
          <p className="text-gray-600 mb-6 leading-relaxed">
            {section.content}
          </p>
          {section.image && (
            <div className="mb-6">
              <img
                src={section.image}
                alt={section.imageAlt || section.title}
                className="w-full h-auto rounded-lg "
              />
              {section.imageCaption && (
                <p className="mt-2 text-sm text-gray-500 italic text-center">
                  {section.imageCaption}
                </p>
              )}
            </div>
          )}
          {section.steps && (
            <ol className="list-decimal pl-6 space-y-3 mb-6">
              {section.steps.map((step, stepIndex) => (
                <li key={stepIndex} className="text-gray-700">
                  {step}
                </li>
              ))}
            </ol>
          )}
          {section.note && (
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6">
              <p className="text-sm text-blue-700">{section.note}</p>
            </div>
          )}
          {section.subsections &&
            section.subsections.map((subsection, index) => (
              <DocSection key={index} section={subsection} level={level + 1} />
            ))}
        </div>
      </div>
    </div>
  );
};

const FeatureDocumentation = ({ title, description, sections }) => {
  return (
    <div className="w-full bg-gray-100 min-h-screen">
      <div className="bg-[#21a179]  p-6 text-white mb-6 text-start pl-10">
        <h2 className="text-2xl font-bold mb-2">{title}</h2>
        <p className="text-lg text-gray-100">{description}</p>
      </div>
      <div className="px-6">
        {sections.map((section, index) => (
          <DocSection key={index} section={section} />
        ))}
      </div>
    </div>
  );
};

export default FeatureDocumentation;
